import React, { createContext, useContext, useEffect, useState } from 'react';
import { useAuth } from './AuthContext';

const CellCogAccessContext = createContext();

export const CellCogAccessProvider = ({ children }) => {
  const { userProfile, profileLoading, profileError, refreshUserProfile } = useAuth();
  const [apiFailure, setApiFailure] = useState(false);

  // Determine if user has access — based on onboarding_status state machine
  const hasAccess = userProfile?.onboarding_status === 'JOINED';

  // Determine why user is blocked (if they are)
  const determineBlockedReason = () => {
    if (!userProfile) return null;

    const status = userProfile.onboarding_status;
    if (status === 'JOINED') return null;
    if (status === 'SECURITY_FLAGGED') return 'SECURITY_FLAGGED';
    if (status === 'SIGNED_UP' || status === 'INVITED') return 'EMAIL_NOT_VERIFIED';
    if (status === 'EMAIL_VERIFIED') return 'CONSENT_PENDING';

    // Fallback for unknown states
    return 'SECURITY_FLAGGED';
  };

  // Track profile API failure
  useEffect(() => {
    if (profileError) {
      setApiFailure(true);
    } else {
      setApiFailure(false);
    }
  }, [profileError]);

  // Manual retry after failure
  const manualRetry = () => {
    setApiFailure(false);
    refreshUserProfile();
  };

  return (
    <CellCogAccessContext.Provider value={{
      loading: profileLoading,
      apiFailure,
      manualRetry,
      hasAccess,
      blockedReason: determineBlockedReason(),
      userEmail: userProfile?.email || '',
    }}>
      {children}
    </CellCogAccessContext.Provider>
  );
};

export const useCellCogAccess = () => useContext(CellCogAccessContext);
